import clone from 'clone';
import internalReportActions from './actions';

const INITIAL_DATA = {
  status: null,
  allRestaurantsList: null,
  loading: true,
  error: null,
};

export default function restaurantListReducer(state = INITIAL_DATA, action) {
  switch (action.type) {
    case internalReportActions.FETCH_RESTAURANTS_LIST_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case internalReportActions.FETCH_RESTAURANTS_LIST_SUCCESS: {
      return {
        ...state,
        allRestaurantsList: action.payload,
        loading: false,
      };
    }
    case internalReportActions.FETCH_RESTAURANTS_LIST_FAILURE: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }
    default:
      return state;
  }
}
